import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UtilidadesService } from '../../utilidades/utilidades.servicios.index';
import { GlobalService } from '../../Servicios/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosService } from '../../Servicios/productos.service';
import { vProductoModel } from '../../Modelo/vProducto.model';
import { PaginacionModel } from '../../Modelo/paginacion.model';
import { CarritoDeComprasService } from '../../Servicios/carrito-de-compras.service';
import { MultiCheckboxModel } from 'src/app/Modelo/multiCheckboxModel';
import { String } from '../../utilidades/Extensions/string-extensions';
import { SwiperOptions } from 'swiper';
import { environment } from 'src/environments/environment';
import { SeriesService } from 'src/app/Servicios/series.service';
import { CategoriasService } from 'src/app/Servicios/categorias.service';
import { CategoriaPrincipalModel } from 'src/app/Modelo/CategoriaPrincipal.model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PaginadorConfig } from 'src/app/utilidades/Configuraciones/paginador.config';
import { SwiperComponent } from 'angular2-useful-swiper';

@Component({
    selector: 'app-productos',
    templateUrl: './productos.component.html',
    styleUrls: ['./productos.component.scss']
})
export class ProductosComponent implements OnInit {
	@ViewChild(MatPaginator, {static: false}) _paginator: MatPaginator;
    @ViewChildren('swiper') swipers: QueryList<SwiperComponent>;
    
    private _totalNumberOfProducts: number = 0;
    private _filterChangeEventsWereRegistered: boolean = false;
    public TextoABuscar: string = "";
    public Lista: vProductoModel[] = [];
    public Paginacion: PaginacionModel = null;
    SliderNavigation = SliderNavigation;
    swiperOptions: SwiperOptions = {
        speed: 500,
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0
    };
    
    get isLoading(): boolean {
        return this.Global.isSearching;
    }

    get selectedTextFiltersLabels(): string {
        return (((this.Global.FiltroProductos.textFilterCategories?.length ?? 0) > 0) && this.Global.FiltroProductos.textFilterCategories.every(t => t.checked)) 
        ? 'Todas las categorías'
        : (this.Global.FiltroProductos.textFilterCategories ?? new Array<MultiCheckboxModel<number>>()).filter(f => f.checked).map(f => { return f.label; }).join(', ');
    }

    get mustShowTextFilters(): boolean {
        return (this.Global.FiltroProductos.textFilterCategories?.length ?? 0) > 0 && 
        this.Global.FiltroProductos.textFilterCategories.filter(t => t.checked).length > 0 && 
        !String.isNullOrWhiteSpace(this.Global.FiltroProductos.TextoABuscar);
    }

    constructor(
        public Utilidades: UtilidadesService,
        public Global: GlobalService,
        public Series: SeriesService,
        public Categorias: CategoriasService,
        public ActivatedRoute: ActivatedRoute,
        private Productos: ProductosService,
        private CarritoDeCompras: CarritoDeComprasService
    ) {
        this.Utilidades._menuAbierto = true;
    }

    public ngOnInit(): void {
        this.subscribeToRoutes();

        this.Paginacion = new PaginacionModel(); 
        this.Paginacion.PaginaSiguiente = -1;
    }

    public ngAfterViewInit(): void {
        this._paginator._intl = PaginadorConfig;
        this._paginator.length = this._totalNumberOfProducts;
        this._paginator.pageIndex = this.Global.FiltroProductos.PaginaActual - 1;
        this._paginator.pageSize = this.Global.FiltroProductos.RegistrosPorPagina;
    }
    
    subscribeToRoutes(): void {
        this.ActivatedRoute.params.subscribe(async params => {
            if (!params?.mainCategoryId || isNaN(params.mainCategoryId)) {
                this.setFilterChangeEvents();
                await this.onProductsSearch();
                
                return;
            }

            this.Categorias.ListaPrincipal().subscribe(cp => {
                try {
                    const mainCategoryFromRoute: CategoriaPrincipalModel = cp.filter(currentMainCategory => { 
                        return currentMainCategory.Id === parseInt(params.mainCategoryId); 
                    })[0] || null;

                    if (mainCategoryFromRoute === null || mainCategoryFromRoute === undefined)
                        return;

                    this.Global.FiltroProductos.CategoriaPrincipal = mainCategoryFromRoute;
                } catch (_) { }
            });

            this.setFilterChangeEvents();
        });
    }

    setFilterChangeEvents(): void {
        if (this._filterChangeEventsWereRegistered)
            return;

        this.Global.FiltroProductos._categoriaPrincipalChange.subscribe(async () => {
            await this.onProductsSearch()
        });

        this.Global.FiltroProductos._categoriaChange.subscribe(async () => {
            await this.onProductsSearch()
        });

        this.Global.FiltroProductos._marcaChange.subscribe(() => {
            if (this.Global.FiltroProductos.Marca === null || 
                this.Global.FiltroProductos.Marca === undefined) {
                    this.Series.Lista().subscribe(async s => {
                        this.Global.ListaSeries = s;
                        await this.onProductsSearch();
                    });
                } else {
                    this.Series.ListaPorMarca(this.Global.FiltroProductos.Marca.IdMarca).subscribe(async s => {
                        this.Global.ListaSeries = s;
                        await this.onProductsSearch();
                    });
                }
        });

        this.Global.FiltroProductos._serieChange.subscribe(async () => {
            await this.onProductsSearch()
        });

        this.Global.FiltroProductos._tipoDeProductoChange.subscribe(async () => {
            await this.onProductsSearch()
        });

        this.Global.SortProducts._sortingChange.subscribe(async () => {
            await this.onProductsSearch()
        });
        
        this.Global.FiltroProductos._textFilterCategoriesChange.subscribe(async () => {
            await this.onProductsSearch()
        });

        this._filterChangeEventsWereRegistered = true;
    }

    async onSearchReset(): Promise<void> {
        this.Global.FiltroProductos.TextoABuscar = String.empty;
        this.clearTextFilters();
        
        try {
            await this.onProductsSearch();    
        } catch (ex) {
            
        }
    }

    async onProductsSearch(): Promise<void> {
        try {            
            if (!this.hasSearchFilters()) {
                this.Paginacion = new PaginacionModel();
                this.Lista = [];
                return;
            }

            if (this.Paginacion === undefined || this.Paginacion === null)
                this.Paginacion = new PaginacionModel();

            this.Paginacion.PaginaSiguiente = -1;
            this.Global.FiltroProductos.PaginaActual = 1;
            this.Lista = new Array<vProductoModel>();

            await this.Buscar();
        } catch (ex) {
            if (environment.Debug)
                console.log(`An error occurred while trying to search products. Detail: ${ex}`);
        }
    }
      
    public Buscar(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                this.Global.isSearching = true;
                this.Global.isSearchingProducts = true;

                this.Productos.Lista(this.Global.FiltroProductos.ObjetoParaPost, this.Global.SortProducts.Sorting).subscribe(p => {
                    this.Lista = p.Items;

                    this.Paginacion.CargarDatos(p);

                    this._totalNumberOfProducts = p.CatidadDeRegistros;
                    this._paginator.pageIndex = this.Global.FiltroProductos.PaginaActual - 1;
                    this._paginator.length = this._totalNumberOfProducts;
                    this._paginator.pageSize = this.Global.FiltroProductos.RegistrosPorPagina;

                    if (this.Utilidades.EsDebug) {
                        console.log(p);
                    }

                    this.Global.isSearching = false;
                    this.Global.isSearchingProducts = false;

                    resolve();
                });
            } catch (error) {
                reject(error);
            }
        })
    }

	onPaginatorNavigation(event: PageEvent): void {
		if (event == null || !this.hasSearchFilters()) {
            this.Paginacion = new PaginacionModel();
            this.Lista = [];
            return;
        }

		this.Global.FiltroProductos.PaginaActual = event.pageIndex + 1;
		this.Global.FiltroProductos.RegistrosPorPagina = event.pageSize;

		this.Buscar().then(_ => {
            window.scroll(0, 0);
        });
	}

    public CargarSiguiente(): void {
        this.Global.isSearching = true;

        this.Global.isSearchingProducts = true;

        this.Productos.ObtenerPagina(this.Global.FiltroProductos.ObjetoParaPost, this.Paginacion.PaginaSiguiente).subscribe(p => {
            this.Lista = this.Lista.concat(p.Items);
            this.Paginacion.CargarDatos(p);

            if (this.Utilidades.EsDebug) {
                console.log(p);
            }

            this.Global.isSearching = false;
            
            this.Global.isSearchingProducts = false;
        });
    }

    public AgregarAlCarrito(item: vProductoModel): void {
        this.CarritoDeCompras.AgregarProducto(item);
	}

    clearTextFilters(): void {
        this.Global.FiltroProductos.textFilterCategories.forEach((currentCheckbox: MultiCheckboxModel<number>) => {
            currentCheckbox.checked = false;
        });
    }

    productHasPdf(product: vProductoModel): boolean {
        return product?.Pdf !== null && product?.Pdf !== undefined && product?.Pdf !== '';
    }

    downloadPdf(product: vProductoModel): void {
        if (!this.productHasPdf(product))
            return;

        window.open(product.Pdf, '_blank');
    }

    onSwiperNavigation(productId: number, navigation: SliderNavigation): void {
        const swiper: any = this.swipers.find((s: any) => s.elementRef.nativeElement.id == `swiper-${productId}`);

        if (swiper === null || swiper == undefined)
            return;

        switch (navigation) {
            case SliderNavigation.Next:
                swiper.swiper.slideNext(100);
                break;
        
            case SliderNavigation.Previous:
                swiper.swiper.slidePrev(100);
                break;
        }
    }

    hasSearchFilters(): boolean {
        return (this.Global.FiltroProductos.Aplicacion?.IdAplicacion ?? 0) > 0 ||
            (this.Global.FiltroProductos.Categoria?.IdCategoria ?? 0) > 0 ||
            (this.Global.FiltroProductos.Marca?.IdMarca ?? 0) > 0 ||
            (this.Global.FiltroProductos.Serie?.IdSerie ?? 0) > 0 ||
            (this.Global.FiltroProductos.TipoDeProducto?.IdTipoProducto ?? 0) > 0 ||
            ((this.Global.FiltroProductos.textFilterCategories?.length ?? 0) > 0 &&
            this.Global.FiltroProductos.TextoABuscar !== null &&
            this.Global.FiltroProductos.TextoABuscar !== undefined &&
            this.Global.FiltroProductos.TextoABuscar !== '');
    }
}

export enum SliderNavigation {
    Previous,
    Next
}